(function() {

    var ALLOY_REPORT_TEMP = 'ALLOY_REPORT_TEMP';
    var cacheObj = {};
    var loaded = false;

    var writeGapTime = 50;
    var lastReadTime = 0;
    var lastWriteTime = 0;

    var writeTimeout = 0;

    var writeLocalStorage = function(key , value){
        var currentTime = + new Date();
        if(currentTime - lastWriteTime > writeGapTime){
            try{
                window.localStorage.setItem(key, value);
            }catch(e){

            }
            
        }else{
            clearTimeout(writeTimeout);
            writeTimeout = setTimeout(function(){
                writeLocalStorage(key , value)
            } , writeGapTime);
        }

    };

    var getCacheObj = function(key) {
        var ret;
        var currentTime = + new Date();

        if (window && window.localStorage && currentTime - lastReadTime > writeGapTime) {
            try{
                ret = window.localStorage.getItem(key);

                if(ret.length > 500 *1024){
                    //缓存大于500k，抛弃
                    ret = null;
                }

                ret = JSON.parse(ret);

                lastReadTime = currentTime;
                cacheObj[key] = ret;
            }catch(e){
                ret = undefined;
            }
            

            return ret || undefined;
        } else {
            return cacheObj[key];
        }
    }

    var setCacheObj = function(key, value) {
        var currentTime = + new Date();
        if (value) {
            if (window && window.localStorage) {
                if(currentTime - lastWriteTime > writeGapTime){
                    try{
                        window.localStorage.setItem(key, JSON.stringify(value));
                    }catch(e){
    
                    }
                    lastWriteTime = currentTime;
                }else{
                    clearTimeout(writeTimeout);
                    writeTimeout = setTimeout(function(){
                        writeLocalStorage(key, JSON.stringify(value))
                    } , writeGapTime);
                }
            }
            cacheObj[key] = value;
            
        } else {
            if (window && window.localStorage) {
                try{
                    window.localStorage.removeItem(key);
                }catch(e){

                }
               
            }
            delete cacheObj[key];
        }
    }

    var saveData = function(type, data) {
        var dataPool = [];
        try {
            // var tmp = localStorage.getItem(ALLOY_REPORT_TEMP);
            // dataPool = JSON.parse(tmp);
            dataPool = getCacheObj(ALLOY_REPORT_TEMP);
            if (!dataPool instanceof Array || !dataPool) {
                dataPool = [];
            }
            dataPool.push({ t: type, d: data });

            setCacheObj(ALLOY_REPORT_TEMP, dataPool);
            // localStorage.setItem(ALLOY_REPORT_TEMP, JSON.stringify(dataPool));
        } catch (e) {
            console.error(e);
        }

        //dataPool.push({ t: type, d: data })
    };

    var types = ['monitor', 'tdw', 'huatuo', 'retcode', 'tdbank' , 'tdw.setDefaultTable', 'tdbank.setDefaultTable', 'tdw.setDefaultData','tdbank.setDefaultData', 'tdw.clearDefaultData', 'tdbank.clearDefaultData' , 'performance' ,'closeLog', 'openLog'];
    var report = {};

    var doReport = function() {
        var dataPool;
        // var tmp = localStorage.getItem(ALLOY_REPORT_TEMP);
        // dataPool = JSON.parse(tmp);
        dataPool = getCacheObj(ALLOY_REPORT_TEMP);

        if (!dataPool instanceof Array) {
            dataPool = [];
        }

        for (var i = 0; i < dataPool.length; i++) {
            try {
                var methodName = dataPool[i].t.split('.');
                if (methodName.length > 1) {
                    if (!report[methodName[0]]) {
                        return;
                    }

                    report[methodName[0]][methodName[1]].apply(this, dataPool[i].d);
                } else {
                    report[methodName[0]].apply(this, dataPool[i].d);
                }
            } catch (e) {
                console.error(e);
            }
        }

        // localStorage.removeItem(ALLOY_REPORT_TEMP);
        setCacheObj(ALLOY_REPORT_TEMP);
        window.__reportWating = false;
    };

    var loadMainScript = function(times) {
        times = times || 0;

		if(typeof window === 'undefined' && typeof document === 'undefined'){
			return
		}

        if (window.QReport.isMain) return;
        if (times < 4) {
            var url = '//s.url.cn/pub/js/alloyreport.js?_bid=2231';
            if (times && times < 3) {
                url = '//s' + times + '.url.cn/pub/js/alloyreport.js'
            } else if (times) {
                url = '//qun.qq.com/pub/js/alloyreport.js'
            }
            var scriptDom = document.createElement('script');
            scriptDom.setAttribute('src', url);

            scriptDom.onload = scriptDom.onreadystatechange = function() {
                if (!loaded && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete")) {
                    loaded = true;

                    if (window.QReport.isMain) {
                        try {
                            // report = window.QReport;
                            window.QReport.reset = (window.AlloyReportCore && window.AlloyReportCore.reset) || function() {}
                            Object.assign(report, window.QReport);
                            doReport();
                        } catch (e) {
                            //http://report.url.cn/cgi-bin/data_report_collection?type=1000000&monitor=[2389673]
                        }
                    } else {
                        loaded = false;

                        switch (times) {
                            case 0:
                                window.QReport.monitor(2396704);
                                break;
                            case 1:
                                window.QReport.monitor(2396705);
                                break;
                            case 2:
                                window.QReport.monitor(2396706);
                                break;
                        }
                        loadMainScript(times + 1);
                    }

                }
            };
            scriptDom.onerror = function() {
                switch (times) {
                    case 0:
                        window.QReport.monitor(2396704);
                        break;
                    case 1:
                        window.QReport.monitor(2396705);
                        break;
                    case 2:
                        window.QReport.monitor(2396706);
                        break;
                }
                loadMainScript(times + 1);
            };


            document.body.appendChild(scriptDom);
        } else {
            // var imgWrap = new Image();
            // imgWrap.src = 'http://report.url.cn/cgi-bin/data_report_collection?type=1000000&monitor=["2396704","2396705","2396706","2396707"]'
        }
    };

    if (typeof Object.assign !== 'function') {
        Object.assign = function(target) {
            'use strict';
            if (!target) {
                throw new TypeError('Cannot convert undefined or null to object');
            }

            target = Object(target);
            for (var index = 1; index < arguments.length; index++) {
                var source = arguments[index];
                if (source) {
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key];
                        }
                    }
                }
            }
            return target;
        };
    }

    for (var i = 0; i < types.length; i++) {
        var type = types[i];

        var methodName = type.split('.');

        var newFunction = (function(type) {

            return function() {
                var array = [];
                for (var l = 0; l < arguments.length; l++) {
                    array.push(arguments[l]);
                }
                saveData(type, array);
            }

        })(type);

        if (methodName.length > 1) {
            if (!report[methodName[0]]) {
                report[methodName[0]] = {};
            }

            report[methodName[0]][methodName[1]] = newFunction
        } else {
            report[methodName[0]] = newFunction;
        }

    }


    if (typeof window !== 'undefined' || typeof document !== 'undefined') {
        if(!window.QReport){
            window.QReport = report;
            window.AlloyReport = report;
            window.__reportWating = true;
    
            loadMainScript(0);
        }
    }

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = window.QReport;
    }

})();
